export default {
  authentication: {
    components: {
      contactPreferences: {
        heading: 'Bądźmy w kontakcie.',
        title: 'Bądźmy w kontakcie.',
        skipButtonText: 'Pomiń ten krok'
      },
      createAccount: {
        backButtonText: 'Plecy',
        heading: 'Utwórz konto',
        title: 'Utwórz konto'
      },
      landing: {
        heading: 'Utwórz konto',
        title: 'Utwórz konto'
      },
      verifyAccount: {
        heading: 'Prawie skończone! Musimy tylko zweryfikować Twoje konto.',
        title: 'Zweryfikuj swoje konto'
      }
    },
    hooks: {
      getAuthStatusProps: {
        accountAlreadyVerified: {
          authPageProps: {
            heading: 'Twoje konto zostało już zweryfikowane.',
            title: 'Twoje konto zostało już zweryfikowane'
          },
          authStatusProps: {
            buttonText: 'Powrót do początku',
            buttonTextLogin: 'Kliknij tutaj aby się zalogować',
            heading: 'Sukces!'
          }
        },
        accountCreated: {
          authPageProps: {
            heading: 'Wszystko gotowe i gotowe!',
            title: 'Wszystko gotowe i gotowe!'
          },
          authStatusProps: {
            buttonText: 'Powrót do początku',
            buttonTextLogin: 'Kliknij tutaj aby się zalogować',
            heading: 'Sukces!'
          }
        },
        errorWithResendEmail: {
          authPageProps: {
            heading: 'Coś poszło nie tak.',
            title: 'Coś poszło nie tak'
          }
        },
        errorWithRetrySignUp: {
          authPageProps: {
            heading: 'Coś poszło nie tak.',
            title: 'Coś poszło nie tak'
          }
        },
        generalCreateAccountError: {
          authPageProps: {
            heading: 'Utwórz konto',
            title: 'Coś poszło nie tak'
          },
          authStatusProps: {
            buttonText: 'Spróbuj jeszcze raz',
            heading: 'Coś poszło nie tak',
            subheading: 'Spróbuj jeszcze raz założyć konto.'
          }
        },
        linkExpiredWithResendEmail: {
          authPageProps: {
            heading: 'Link weryfikacyjny wygasł.',
            title: 'Link weryfikacyjny wygasł'
          }
        }
      }
    }
  },
  myHub: {
    collection: {
      calloutText: 'Zapisz elementy i stwórz kolekcje na darmowym koncie',
      errorMessage: 'Nie można pobrać kolejnych elementów. Spróbuj jeszcze raz później.',
      taglineItem_one: 'element',
      taglineItem_few: 'elementy',
      taglineItem_many: 'elementów',
      taglineItem_0: 'element',
      taglineItem_1: 'elementy',
      taglineItem_2: 'elementów'
    },
    collections: {
      taglineSaved: 'zapisane',
      createButtonText: 'Utwórz nową kolekcję',
      loadErrorMessage: 'Nie można pobrać kolejnych elementów. Spróbuj jeszcze raz później.',
      tagline_one: 'kolekcja',
      tagline_few: 'kolekcje',
      tagline_many: 'kolekcji',
      tagline_0: 'kolekcja',
      tagline_1: 'kolekcje',
      tagline_2: 'kolekcji'
    },
    components: {
      savedItem: {
        card: {
          ariaLabel: {
            save: 'Zapisz',
            unsave: 'Cofnij zapis'
          }
        }
      },
      searchFilter: {
        ariaLabel: {
          searchButton: 'szukaj'
        },
        filteredResultsHeading: 'Wyniki dla:',
        sr: {
          filteredItemsResults_one: 'wynik',
          filteredItemsResults_few: 'wyniki',
          filteredItemsResults_many: 'wyników',
          filteredItemsResults_0: 'wyniki',
          filteredItemsResults_1: 'wynik',
          filteredItemsResults_2: 'wyników'
        }
      }
    },
    overview: {
      createButtonText: 'Utwórz nową kolekcję',
      defaultTitle: 'Moja Przestrzeń',
      ugcButtonLabel: 'Zobacz więcej',
      ugcCreateButtonText: 'Dodaj przepis'
    },
    ownItems: {
      createButtonText: 'Dodaj nowy przepis',
      loadErrorMessage: 'Nie można pobrać kolejnych elementów. Spróbuj jeszcze raz później.',
      tabData: {
        all: 'Wszystko',
        published: 'Opublikowane',
        unpublished: 'Nieopublikowane'
      },
      tabFilterError: 'Wystąpił problem z filtrowaniem Twoich przepisów. Wyświetlamy wszystkie przepisy.'
    },
    savedItems: {
      collectionTaglineItem_one: 'element',
      collectionTaglineItem_few: 'elementy',
      collectionTaglineItem_many: 'elementów',
      collectionTaglineItem_0: 'element',
      collectionTaglineItem_1: 'elementy',
      collectionTaglineItem_2: 'elementów',
      collectionTaglineSaved: 'zapisane',
      loadErrorMessage: 'Nie można pobrać kolejnych elementów. Spróbuj jeszcze raz później.'
    }
  },
  nextCore: {
    signIn: {
      errorLineOne: 'Szukasz czegoś konkretnego?',
      errorLineTwo: 'Zaloguj',
      errorLineThree: 'się,',
      errorLineFour: 'żeby zobaczyć stronę.',
      errorLineFive: 'Jeszcze nie utworzyłeś swojego darmowego konta?',
      errorLineSix: 'Dołącz do nas'
    }
  },
  postCreator: {
    confirmation: {
      metaTitle: 'Utwórz przepis - Dziękuję',
      newRecipeButtonText: 'Nowy przepis',
      ownRecipeButtonText: 'Moje Przepisy'
    },
    create: {
      metaTitle: 'Utwórz przepis'
    },
    edit: {
      editFormTitle: 'Edytuj przepis',
      metaTitle: 'Edytuj przepis'
    },
    recipeDetails: {
      dropDownOptions: {
        hours: 'godziny',
        mins: 'min'
      },
      heading: 'Szczegóły przepisu',
      label: {
        cookTime: 'Czas gotowania (średnio)',
        difficulty: 'Poziom trudności',
        extraTime: 'Dodatkowy czas (opcjonalnie)',
        image: 'Obrazek',
        prepTime: 'Czas przygotowania (średnio)',
        servings: 'Porcje',
        shortIntro: 'Krótkie wprowadzenie (10-15 słów)',
        title: 'Tytuł przepisu (krótki i opisowy)'
      },
      placeholder: {
        extraTime: 'np. plus przerwa',
        makes: 'np. 8 kawałków',
        serves: 'np. 4',
        shortIntro: 'Opowiedz nam o swoim przepisie',
        title: 'np. Szarlotka mamy'
      },
      servingsButton: {
        makes: 'Robić',
        serves: 'Dostarczać'
      },
      skillLevel: {
        dropDownOptions: {
          challenge: 'Wyzwanie',
          defaultText: '(Wybierz z listy)',
          easy: 'Łatwy',
          moreEffort: 'Więcej wysiłku'
        }
      }
    },
    recipeForm: {
      defaultFeedback: {
        error: 'Ups! Coś poszło nie tak',
        info: 'Zachowaj obrazek przed wysłaniem'
      },
      links: {
        back: 'Powrót do moich przepisów',
        preview: 'Podgląd',
        saveDraft: 'Zachowaj szkic'
      }
    },
    recipeIngredients: {
      heading: 'Składniki',
      information: {
        lineOne: 'Możesz podzielić swoje składniki na grupy np. sos, nadzienie itd.',
        lineTwo: 'z naszego',
        lineThree: 'przelicznika)',
        lineFour: 'Możesz podzielić swoje składniki na grupy np. sos, nadzienie itd.)'
      },
      ingredient: {
        buttonText: 'Dodaj kolejny składnik',
        label: 'Składnik',
        placeholder: '500g udek z kurczaka, pokrojonych w kostkę'
      },
      ingredientGroup: {
        buttonText: 'Dodaj nagłówek grupujący',
        heading: 'Nagłówek',
        placeholder: 'Do sosu'
      }
    },
    recipeMethodSteps: {
      heading: 'Metoda',
      method: {
        buttonText: 'Dodaj kolejny krok',
        label: 'Krok',
        placeholder: 'Najpierw ugotuj ryż'
      }
    },
    statusFeedback: {
      createLinkeText: 'stworzyć nowy przepis',
      info: {
        approved: 'Twój przepis został zatwierdzony',
        "default": 'Ups, coś poszło źle',
        draft: 'Twój przepis nie został jeszcze wysłany',
        pending: 'Twój przepis nie został jeszcze wysłany',
        rejected: 'Twój przepis nie został zatwierdzony'
      },
      submissionChoice: {
        approved: 'zobaczyć swój przepis',
        "default": 'wrócić do listy przepisów',
        draft: 'edytować swój przpeis',
        heading: 'A może chcesz'
      },
      submittedText: 'Twój przepis został wysłany do zatwierdzenia i nie możesz go edytować.'
    },
    submit: {
      formValidation: {
        defaultMessage: 'Potwierdź, że zapoznałeś się z zasadami i warunkami'
      },
      informationLineOne: 'Pamiętaj, żeby dodawać tylko własne przepisy.',
      informationLineTwo: 'Ze względu na prawa autorskie nie możemy opublikować żadnego z  przepisów',
      informationLineThree: 'dodanych przez naszych czytelników, które zostały stworzone przez osoby trzecie. Zanim wyślesz przepis przeczytaj nasze',
      informationLineFour: 'zasady i warunki,',
      informationLineFive: 'aby uzyskać więcej informacji.',
      metaTitle: 'Utwórz przepis - Zasady i warunki',
      previewButtonText: 'Podgląd',
      publishButtonText: 'Opublikuj',
      termsLabel: 'Zaznacz, że zapoznałeś się z naszymi zasadami i warunkami.'
    }
  }
};